import type { ComponentType, SVGProps } from 'react';

interface ControlButtonProps {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  isActive: boolean;
  disabled: boolean;
  onClick: () => void;
}

export function ControlButton({
  icon: Icon,
  title,
  isActive,
  disabled,
  onClick,
}: ControlButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      aria-pressed={isActive}
      disabled={disabled}
      className={`grid h-10 w-9 shrink-0 place-items-center rounded-md border min-[721px]:w-10 ${
        disabled
          ? 'border-line bg-panel text-zinc-700'
          : isActive
            ? 'border-gold/40 bg-gold/[.06] text-gold'
            : 'border-line-strong bg-panel text-subtle hover:text-fg'
      }`}
    >
      <Icon aria-hidden="true" width={16} height={16} />
    </button>
  );
}
